import { Field, FormikErrors, FormikTouched } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';
import { FormStepHeader } from '../../../../components/forms';
import { FormSelect } from '../../../../components/tables/filterForms/FormSelect';
import { useGetAllScholarshipsQuery } from '../../../../services/endpoints/orders/scholarship';
import { useGetCoursesSimpleQuery } from '../../../../services/endpoints/schedule/course';
import { Scholarship } from '../../../../types/orders.type';
import { scholarshipTypes } from '../../../../utils/consts/orders/scholarships';

export interface FormValues {
  user_id: { value?: number; label: string };
  scholarship_id: { value?: number; label: string };
  course_id?: { value?: number; label: string };
  child_ids?: [];
}
export interface StepProps {
  errors: Partial<FormikErrors<FormValues>>;
  touched: Partial<FormikTouched<FormValues>>;
  values?: FormValues;
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
  readOnly?: boolean;
}
type Overwrite<T, NewT> = Omit<T, keyof NewT> & NewT;

export type CreateFormValues = Overwrite<
  FormValues,
  {
    parent_id: number;
    scholarship_id: number;
    course_id?: number;
    childs_id?: [];
  }
>;
export const OrdersForm = ({ touched, errors, values, setFieldValue }: StepProps) => {
  const { data: scholarshipData, error: scholarshipError } = useGetAllScholarshipsQuery({
    data: { entries: 1000 }
  });
  const { data: courseData, error: courseError } = useGetCoursesSimpleQuery({
    scope: 'upcoming',
    data: {
      entries: 10000,
      orderBy: { field: 'title', order: 'asc' }
    }
  });

  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="New Order" className="mb-3" />
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        {/* <Form.Group className="mb-1 mb-lg-3" controlId="user_id">
          <Field 
            as={FormSelect}
            name="user_id"
            label="User"
            options={parentData?.results?.map((user: User) => ({
              value: user.id,
              label: `${user.first_name} ${user.last_name} (${user.email})`,
            })) ?? []}
            loadingError={parentError ? 'Error loading users': undefined}
          />
          <Form.Text>Enter first name, last name, or email address to find the relevant user.</Form.Text>
        </Form.Group> */}
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="course_id"
        >
          <Field
            as={FormSelect}
            name="course_id"
            label="Upcoming Session"
            required
            options={
              courseData?.results?.map((course: { id: number; title: string }) => ({
                value: course.id,
                label: course.title
              })) ?? []
            }
            loadingError={courseError ? 'Error loading sessions' : undefined}
          />
        </Form.Group>

        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="scholarship_id"
        >
          <Field
            as={FormSelect}
            name="scholarship_id"
            label="Scholarship"
            required
            options={
              scholarshipData?.results
                ?.filter((r) => r.percent_discount === 100)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((item: Scholarship) => ({
                  value: item.id,
                  label: `${scholarshipTypes[item.scholarship_type]} (${item.percent_discount}% off)`
                })) ?? []
            }
            loadingError={scholarshipError ? 'Error loading scholarships' : undefined}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};
